import { createTypes, createAction } from 'lib/action'

const LOAD_DYNAMIC_SIDEBAR = createTypes('loadDynamiSidebar', 'load')
const LOAD_DYNAMIC_SIDEBAR_DETAIL = createTypes(
  'loadDynamicSidebarDetail',
  'load'
)
const CREATE_DYNAMIC_SIDEBAR = createTypes('createDynamicSidebar', 'create')
const UPDATE_DYNAMIC_SIDEBAR = createTypes('updateDynamicSidebar', 'update')
const DELETE_DYNAMIC_SIDEBAR = createTypes('deleteDynamicSidebar', 'delete')

const LOAD_DYNAMIC_SIDEBAR_MENU_HIERARCHY = createTypes(
  'loadDynamicSidebarMenuHierarchy',
  'load'
)

const REMOVE_LISTS = `REMOVE_LISTS`

function removeLists() {
  return {
    type: REMOVE_LISTS,
  }
}
const loadDynamicSidebar = {
  request: (data, loading) =>
    createAction(LOAD_DYNAMIC_SIDEBAR.REQUEST, { data, loading }),
  success: (lists, page) =>
    createAction(LOAD_DYNAMIC_SIDEBAR.SUCCESS, { lists, page }),
  failure: () => createAction(LOAD_DYNAMIC_SIDEBAR.FAILURE),
}

const loadDynamicSidebarDetail = {
  request: (data) =>
    createAction(LOAD_DYNAMIC_SIDEBAR_DETAIL.REQUEST, { data }),
  success: (data) =>
    createAction(LOAD_DYNAMIC_SIDEBAR_DETAIL.SUCCESS, { data }),
  failure: () => createAction(LOAD_DYNAMIC_SIDEBAR_DETAIL.FAILURE),
}

const createDynamicSidebar = {
  request: (data, cb) =>
    createAction(CREATE_DYNAMIC_SIDEBAR.REQUEST, {
      data,
      cb,
    }),
  success: (res) => createAction(CREATE_DYNAMIC_SIDEBAR.SUCCESS, { res }),
  failure: () => createAction(CREATE_DYNAMIC_SIDEBAR.FAILURE),
}

const updateDynamicSidebar = {
  request: (data, cb) =>
    createAction(UPDATE_DYNAMIC_SIDEBAR.REQUEST, {
      data,
      cb,
    }),
  success: (res) => createAction(UPDATE_DYNAMIC_SIDEBAR.SUCCESS, { res }),
  failure: () => createAction(UPDATE_DYNAMIC_SIDEBAR.FAILURE),
}

const deleteDynamicSidebar = {
  request: (data, cb) =>
    createAction(DELETE_DYNAMIC_SIDEBAR.REQUEST, {
      data,
      cb,
    }),
  success: (res) => createAction(DELETE_DYNAMIC_SIDEBAR.SUCCESS, { res }),
  failure: () => createAction(DELETE_DYNAMIC_SIDEBAR.FAILURE),
}

const loadDynamicSidebarMenuHierarchy = {
  request: (data) =>
    createAction(LOAD_DYNAMIC_SIDEBAR_MENU_HIERARCHY.REQUEST, { data }),
  success: (data) =>
    createAction(LOAD_DYNAMIC_SIDEBAR_MENU_HIERARCHY.SUCCESS, { data }),
  failure: () => createAction(LOAD_DYNAMIC_SIDEBAR_MENU_HIERARCHY.FAILURE),
}

export {
  CREATE_DYNAMIC_SIDEBAR,
  createDynamicSidebar,
  loadDynamicSidebar,
  LOAD_DYNAMIC_SIDEBAR,
  REMOVE_LISTS,
  removeLists,
  LOAD_DYNAMIC_SIDEBAR_DETAIL,
  loadDynamicSidebarDetail,
  updateDynamicSidebar,
  UPDATE_DYNAMIC_SIDEBAR,
  deleteDynamicSidebar,
  DELETE_DYNAMIC_SIDEBAR,
  loadDynamicSidebarMenuHierarchy,
  LOAD_DYNAMIC_SIDEBAR_MENU_HIERARCHY,
}
